<template>
  <div class="page-content delivery-need-love">
    <div class="row">
      <div class="col-12">
        <create-need-love />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { nextTick, onMounted } from 'vue';
import { useRoute } from 'vue-router';

import util from '@/Utils/util';

import CreateNeedLove from './DeliveryNeedLove/CreateNeedLove.vue';

export default {
  name: 'DeliveryNeedLove',

  components: {
    CreateNeedLove,
  },

  setup: () => {
    onMounted(async () => {
      const route = useRoute();
      const { hash } = route;

      await nextTick();
      util.moveScrollComponent(hash);
    });
  },
};
</script>
